import React from 'react'
import PdfPage from '../components/PdfPage'
import "./index.css"

const PsxRuleBook = () => {
  return (
    <main className="main-container">
      <PdfPage
        h2={"Psx Rule Book"}
        img={"/img/PSX-logo.jpg"}
        pdf1={"/img/PSX-Rule-Book-English.pdf"}
        pdf1Text={"Download File In English"}
        pdf2={"/img/PSX-Rule-Book-Urdu.pdf"}
        pdf2Text={"Download In Urdu"}
      />
    </main>)
}

export default PsxRuleBook